<template>
  <div class="admin-add-container">
    <div class="admin-add-content">
      <div class="admin-add-header">
        <h2>添加管理员</h2>
        <p>创建新的管理员账号并分配权限</p>
      </div>

      <div class="admin-list-section">
        <el-table :data="adminList" style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="username" label="用户名" width="150"></el-table-column>
          <el-table-column prop="email" label="邮箱" width="200"></el-table-column>
          <el-table-column prop="role" label="角色" width="120">
            <template slot-scope="scope">
              <el-tag :type="scope.row.role === 'super_admin' ? 'danger' : 'primary'" size="mini">
                {{ scope.row.role === 'super_admin' ? '超级管理员' : '普通管理员' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="permissions" label="权限" width="200">
            <template slot-scope="scope">
              <el-tag v-for="perm in scope.row.permissions" :key="perm" size="mini" style="margin-right: 4px;">
                {{ perm }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" width="180"></el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 'active' ? 'success' : 'info'" size="mini">
                {{ scope.row.status === 'active' ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="mini" @click="editAdmin(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="deleteAdmin(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-divider content-position="left">{{ isEditing ? '编辑管理员' : '添加新管理员' }}</el-divider>

      <el-form :model="form" :rules="rules" ref="form" label-width="120px" class="add-form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户名" prop="username">
              <el-input v-model="form.username" placeholder="请输入用户名" :disabled="isEditing"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="密码" :prop="isEditing ? '' : 'password'">
              <el-input v-model="form.password" type="password" :placeholder="isEditing ? '留空则不修改密码' : '请输入密码'" show-password></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="确认密码" :prop="isEditing ? '' : 'confirmPassword'">
              <el-input v-model="form.confirmPassword" type="password" placeholder="请再次输入密码" show-password></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="角色" prop="role">
              <el-select v-model="form.role" placeholder="请选择角色" style="width: 100%">
                <el-option label="超级管理员" value="super_admin"></el-option>
                <el-option label="普通管理员" value="admin"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-switch v-model="form.statusActive" active-text="启用" inactive-text="禁用"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="权限" prop="permissions">
          <el-checkbox-group v-model="form.permissions">
            <el-checkbox label="user_manage">用户管理</el-checkbox>
            <el-checkbox label="content_manage">内容管理</el-checkbox>
            <el-checkbox label="order_manage">订单管理</el-checkbox>
            <el-checkbox label="system_setting">系统设置</el-checkbox>
            <el-checkbox label="model_manage">模型管理</el-checkbox>
            <el-checkbox label="subscription_manage">订阅管理</el-checkbox>
            <el-checkbox label="payment_setting">支付设置</el-checkbox>
            <el-checkbox label="view_stats">查看统计</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注信息（可选）"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="submitting">
            {{ isEditing ? '保存修改' : '添加管理员' }}
          </el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminAdd',
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (this.isEditing) {
        callback()
        return
      }
      if (value !== this.form.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      adminList: [],
      loading: false,
      submitting: false,
      isEditing: false,
      editingId: null,
      form: {
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        role: 'admin',
        statusActive: true,
        permissions: [],
        remark: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' }
        ],
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        permissions: [
          { type: 'array', required: true, message: '请至少选择一个权限', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.loadAdminList()
  },
  methods: {
    async loadAdminList() {
      this.loading = true
      try {
        const res = await this.$axios.get('/admin/admins/list')
        if (res.data.code === 200) {
          this.adminList = res.data.data
        }
      } catch (err) {
        console.log('获取管理员列表失败，使用模拟数据')
        this.adminList = [
          {
            id: 1,
            username: 'admin',
            email: 'admin@example.com',
            role: 'super_admin',
            permissions: ['user_manage', 'content_manage', 'order_manage', 'system_setting', 'model_manage', 'subscription_manage', 'payment_setting', 'view_stats'],
            created_at: '2024-01-01 00:00:00',
            status: 'active'
          }
        ]
      } finally {
        this.loading = false
      }
    },
    editAdmin(admin) {
      this.isEditing = true
      this.editingId = admin.id
      this.form = {
        username: admin.username,
        email: admin.email,
        password: '',
        confirmPassword: '',
        role: admin.role,
        statusActive: admin.status === 'active',
        permissions: [...admin.permissions],
        remark: admin.remark || ''
      }
      this.$message.info('正在编辑管理员: ' + admin.username)
    },
    async deleteAdmin(admin) {
      if (admin.role === 'super_admin') {
        this.$message.warning('无法删除超级管理员')
        return
      }
      try {
        await this.$confirm('确定要删除管理员 ' + admin.username + ' 吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch {
        return
      }

      try {
        const res = await this.$axios.delete(`/admin/admins/${admin.id}`)
        if (res.data.code === 200) {
          this.$message.success('删除成功')
          this.loadAdminList()
        }
      } catch (err) {
        this.$message.error('删除失败')
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            const data = {
              username: this.form.username,
              email: this.form.email,
              role: this.form.role,
              status: this.form.statusActive ? 'active' : 'inactive',
              permissions: this.form.permissions,
              remark: this.form.remark
            }
            if (this.form.password) {
              data.password = this.form.password
            }

            let res
            if (this.isEditing) {
              res = await this.$axios.put(`/admin/admins/${this.editingId}`, data)
            } else {
              res = await this.$axios.post('/admin/admins/create', data)
            }

            if (res.data.code === 200) {
              this.$message.success(this.isEditing ? '修改成功' : '添加成功')
              this.resetForm()
              this.loadAdminList()
            } else {
              this.$message.error(res.data.message || '操作失败')
            }
          } catch (err) {
            this.$message.error('操作失败')
          } finally {
            this.submitting = false
          }
        }
      })
    },
    resetForm() {
      this.isEditing = false
      this.editingId = null
      this.form = {
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        role: 'admin',
        statusActive: true,
        permissions: [],
        remark: ''
      }
      this.$refs.form && this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.admin-add-container {
  padding: 20px 0;
}

.admin-add-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.admin-add-header {
  margin-bottom: 30px;
}

.admin-add-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.admin-add-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.admin-list-section {
  margin-bottom: 30px;
}

.add-form {
  max-width: 800px;
}

.el-form-item__label {
  color: #666;
  font-weight: 500;
}

.el-button--primary {
  background: linear-gradient(135deg, #00e6ac, #00cc99);
  border: none;
  color: #000;
  font-weight: 600;
}

.el-button--primary:hover {
  background: linear-gradient(135deg, #00cc99, #00b386);
  color: #000;
}

.el-divider {
  color: #333;
  font-weight: 600;
}
</style>
